
import {mapGetters, mapState} from 'vuex'
import Popup from 'vux/src/components/popup/index.vue'


import HeaderCommon from '../../components/Header/Header'
import Cell from '../../components/Cell/Cell'

import {SET_CURRENT_LOCALE, SET_LOCALE_POP_VISIBLE} from '../../store/nameSpace'
import i18n, {i18nLocales} from '../../i18n'

export default {
name: 'Locales',
components: { Popup, HeaderCommon, Cell },
data () {
return {
nextLocale: i18n.locale()
}
},
computed: {
...mapGetters([
'localeList'
]),
...mapState({
localePopVisible: state => state.app.localePopVisible
}),
currentVisibleVModel: {
get () {
return this.localePopVisible
},
set (val) {
this.$store.commit(SET_LOCALE_POP_VISIBLE, val)
}
},
sysLocaleConfigList () {
if (!this.localeList) return []
return this.localeList.filter(item => item.enabled).map(item => {
return {
...i18nLocales[item.code],
...item
}
})
}
},
watch: {
cacheInfo () {
if (this.currentVisibleVModel) {
this.$store.dispatch('getSysLocaleList')
}
},
currentVisibleVModel (val) {
if (val) {
this.$store.dispatch('getSysLocaleList')
} else {
setTimeout(() => {
this.nextLocale = i18n.locale()
}, 400)
}
}
},
methods: {
saveLocale () {
if (this.nextLocale === this.locale) {
this.currentVisibleVModel = false
} else {
this.$i18n.set(this.nextLocale)
this.$locale.set(this.nextLocale)
this.$store.commit(SET_CURRENT_LOCALE, this.nextLocale)
this.currentVisibleVModel = false
}
},
closePop () {
this.currentVisibleVModel = false
}
}
}



// WEBPACK FOOTER //
// ./src/views/Locales/Locales.vue